const Progressbar = ({ aktuell, summe, naechste }) => {
  const stuffenDiff = naechste.credits - aktuell.credits;
  const progress = summe - aktuell.credits;
  const neededCred = naechste.credits - summe;

  return (
    <div className="container-progress career-item">
      <div className="grid-progress">
        {summe !== "X" ? (
          <>
            <span>{aktuell.name}</span>
            <progress
              id="progressbar"
              max={stuffenDiff}
              value={progress}
            ></progress>
            <span className="next">{naechste.name}</span>
            <label htmlFor="progressbar">
              Noch {neededCred} Punkt{neededCred != 1 && "e"}
            </label>
          </>
        ) : (
          <>
            <progress id="progressbar" max={1} value={1}></progress>
            <p className="max-role">{aktuell.name}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default Progressbar;
